
import { defineComponent, PropType, computed, reactive, onMounted, toRaw, watch } from "vue";
export default defineComponent({
  props: {
      modelValue: {
         type: [String, Number],
         default: "",
      },
      data: {
         type: Array as PropType<any[]>,
         default: () => [],
      },
      props: {
         type: Object,
         default: () => {
            return {
               label: "projectName",
               id: "id",
            };
         },
      },
      showBadge:{
         type: [Boolean],
         default: false,
      }
   },
   setup(props) {
      const searchParams: any = reactive({
         projectYear:'',
         projectName:'',
         height:'100px',
         dataList:[],
      });

      watch(
			() => props.data,
			(val) => {
            searchParams.dataList = val;
			}
		);

      const changeYearFn = ()=>{
         searchParams.dataList = props.data.filter((item: any)=>{ return item.projectName.indexOf(searchParams.projectName) !== -1 && (searchParams.projectYear?item.year == searchParams.projectYear:true) });
      }

      const changeNamgeFn = ()=>{
         searchParams.dataList = props.data.filter((item: any)=>{ return item.projectName.indexOf(searchParams.projectName) !== -1 && (searchParams.projectYear?item.year == searchParams.projectYear:true) });
      }

      onMounted(() => {
         searchParams.height = window.innerHeight - 220 +'px';
         window.onresize = ()=>{
            searchParams.height = window.innerHeight - 220 +'px';
         }
      });
      return {
         searchParams,
         changeYearFn,
         changeNamgeFn
      };
   },
});
